<div class="error-container">
  <img [src]="config.route" [alt]="config.title" />
  <p class="text" *ngIf="!moreInfoService.moreInfoData.otpErrorGenerate">
    <strong>{{ config.title }}</strong>
    <br />
    {{ config.content }}
  </p>

  <p class="text" *ngIf="moreInfoService.moreInfoData.otpErrorGenerate">
    <strong>Vemos que superaste los intentos permitidos para generar el código.
    </strong>
    <br />
    {{ config.content }}
  </p>
  <div class="container box-link" *ngIf="config.redirect">
    <button class="btn btn-degraded blue link" href="#" [routerLink]="config.redirect.url">{{ config.redirect.text
      }}</button>
  </div>
</div>